import { formatUIDate } from 'utils/helpers'
import { NoDailyReportReportPayloadItem } from '../interfaces'

export const toTableRowItems = (items: NoDailyReportReportPayloadItem[]) =>
  items.map(item => ({
    id: item.id,
    sapId: item.sapId ?? '',
    dateOfRegularization: formatUIDate(item.dateOfRegularization),
    dateOfLastDailyReport: formatUIDate(item.dateOfLastDailyReport),
    storeName: item.storeName ?? '',
    legalEntityName: item.legalEntity ?? '',
    wasteCategoryName: item.wasteCategoryName ?? '',
  }))
